import {useContext} from 'react';
import UserContext, {UserContextValue} from './UserContext';

export default function useUserContext(): UserContextValue {
  return useContext(UserContext);
}
